import React, { FC } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SearchPostsFilter } from 'api';

import { initialPostFilter, useSearchESContext } from 'features/search/SearchESContext';

interface Props {
  tempFilters: SearchPostsFilter;
  setTempFilters: (filters: SearchPostsFilter) => void;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  submitButton: {
    borderRadius: theme.spacing(5),
  },
}));

const SearchFilterButtons: FC<Props> = ({ tempFilters, setTempFilters, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { dispatch } = useSearchESContext();

  function onClickClear() {
    setTempFilters(initialPostFilter);
  }

  function onSubmit() {
    dispatch({ type: 'setPostFilter', value: tempFilters });
    onClose();
  }

  return (
    <Grid container alignItems="center" justify="flex-end" spacing={2}>
      <Grid item>
        <Button
          className={classes.submitButton}
          variant="contained"
          onClick={onClickClear}
          size="large"
        >
          {t('common:clear')}
        </Button>
      </Grid>

      <Grid item>
        <Button
          className={classes.submitButton}
          variant="contained"
          color="primary"
          size="large"
          onClick={onSubmit}
        >
          {t('common:apply')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default SearchFilterButtons;
